// --------------------------------------------------------
// QUESTIONNAIRE HEADER - QuestionnaireHeader
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Avatar } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Colors from '../../../constants/Colors'
import useFetchPhoto from '../../../hooks/useFetchPhoto'
import { TextLink } from '../../../pages/medicalRecord/components/attendanceRecord/components/details/DetailsAttendanceRecord.styled'
import { H1 } from '../generalLayout/Layout.styled'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// QUESTIONNAIRE HEADER INTERFACE
// --------------------------------------------------------

interface IQuestionnaireHeader {
    pessoa: any
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const QuestionnaireHeader = ({ pessoa }: IQuestionnaireHeader) => {
    // --------------------------------------------------------
    // QUESTIONNAIRE HEADER PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [photo, setPhoto] = useState<any>();
    useFetchPhoto(pessoa.foto, setPhoto)
    const navigate = useNavigate();

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <div style={{ marginBottom: 30 }}>
            <div style={{ marginBottom: 20 }}>
                <TextLink color={Colors.SPM600} onClick={()=>{ navigate(-1) }}>{'< Voltar para prontuário'}</TextLink>
            </div>
            <div style={{ flexDirection: 'row', display: 'flex', gap: 20, marginBottom: 15 }}>
                <Avatar src={photo} sx={{ width: 70, height: 70 }} />
                <H1>{pessoa.nome}</H1>
            </div>
            <H1>Respostas</H1>
        </div>
    )
    // --------------------------------------------------------
}

export default QuestionnaireHeader